module.exports = __webpack_public_path__ + "files/17cb12b7fc37d8229a6e72f3d6da0949.png";


//////////////////
// WEBPACK FOOTER
// ./images/favicon/apple-touch-icon-76x76.png
// module id = 1204
// module chunks = 60